export default __webpack_public_path__ + "assets/icons/eu.ee8f48a0.svg";